import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    vaccinations: [],
    lastFetch: null,
    total: 0,
    missed: 0,
    upcoming: 0,
    completed: 0,
    missedData: [],
    completedData: [],
    upcomingData: [],
    active: 0,
    beep: true,
};

const filterData = (newVaccines) => {
    const total = newVaccines.length;
    let missed = 0;
    let completed = 0;
    let upcoming = 0;
    let missedData = [];
    let completedData = [];
    let upcomingData = [];
    const currentDate = new Date().toISOString();

    newVaccines.forEach((data) => {
        if (!data.status) {
            if (data.dueDate >= currentDate) {
                upcoming++;
                upcomingData.push(data);
            } else {
                missed++;
                missedData.push(data);
            }
        } else {
            completed++;
            completedData.push(data);
        }
    });

    return {
        total,
        missed,
        completed,
        upcoming,
        missedData,
        completedData,
        upcomingData,
    };
};

const vaccinationsSlice = createSlice({
    name: "vaccinations",
    initialState,
    reducers: {
        setVaccinations: (state, action) => {
            const newVaccines = [...action.payload];
            const {
                total,
                missed,
                completed,
                upcoming,
                missedData,
                completedData,
                upcomingData,
            } = filterData(newVaccines);

            state.vaccinations = [...newVaccines];
            state.lastFetch = Date.now();
            state.total = total;
            state.missed = missed;
            state.completed = completed;
            state.upcoming = upcoming;
            state.missedData = missedData;
            state.completedData = completedData;
            state.upcomingData = upcomingData;
        },
        resetVaccinations: (state) => {
            state.vaccinations = [];
            state.lastFetch = null;
            state.total = 0;
            state.missed = 0;
            state.completed = 0;
            state.upcoming = 0;
            state.missedData = [];
            state.completedData = [];
            state.upcomingData = [];
        },
        setActiveCard: (state, action) => {
            state.active = action.payload;
        },
        setBeep: (state, action) => {
            state.beep = action.payload;
        },
    },
});

export const { setVaccinations, resetVaccinations, setActiveCard, setBeep } = vaccinationsSlice.actions;
export default vaccinationsSlice.reducer;